import { useEffect, useState } from 'react';
import { MenuItem, Select } from '@mui/material';
import { GridRenderEditCellParams } from '@mui/x-data-grid';

import { getPossibleAttributeValues } from '@/generated/client/targetattributes/targetattributes';
import { TargetAttributeEnumDto } from '@/generated/model';
import { useTranslation } from 'react-i18next';

export default function RemoteListEditor({ params }: { params: GridRenderEditCellParams }) {
  const { id, field, row, api } = params;
  const { t } = useTranslation();
  const [possibleValues, setPossibleValues] = useState<TargetAttributeEnumDto[] | undefined>();

  useEffect(() => {
    async function loadPossibleValues() {
      const newValues = (await getPossibleAttributeValues({ key: row.possibleValueDescriber })).data;
      setPossibleValues(newValues);
    }
    void loadPossibleValues();
  }, []);

  if (!possibleValues) {
    return <span className="target-attribute-value disabled">{t('targetAttributes.pleaseWait')}</span>;
  }
  return (
    <Select
      className="target-attribute-value"
      value={row.value.id ?? ''}
      onChange={async (e) => {
        const selected = possibleValues.find((vehicle) => vehicle.id === e.target.value);
        await api.setEditCellValue({ id, field, value: selected });
      }}
      autoFocus
    >
      {possibleValues.map((value) => (
        <MenuItem value={value.id}>{value.translation}</MenuItem>
      ))}
    </Select>
  );
}
